<template>
    <div ref="container" class='position-relative h-100 w-100'>

        <loading ref="loading"></loading>

        <div v-if='survey' class="card d-flex flex-column h-100">

            <header ref="header" class="p-2 header__dashboard--top scroller-header-shadow">
                <patient-banner
                    v-if='form_user'
                    v-bind:user.sync='form_user' />
                <hr />
                <h2 class="h4 mb-0">Form: <template v-if='form_submission && form_submission.form_version'>{{ form_submission.form_version.title }}</template></h2>
            </header>

            <div ref="editScroller" class="scroller card-body pt-2 flex-grow-1-scroll bg-light">
                <local-error v-bind:errors='errors' v-bind:inline='inline_errors'></local-error>
                <div class='container w-100' v-show="signpost_items_visible">
                    <div class="card-button w-100 mb-2 p-3" v-if="keyword_question && keywords">
                        <div class="form-group w-100">
                            <label class="mb-3">{{ keyword_question.title }}</label>
                        
                            <input type="text" disabled readonly class="form-control w-100" v-model="keywords">
                        </div>
                    </div>
                    <h3 class="pt-3 pb-3">{{ $t('translations.signpost_title') }}</h3>
                    <custom-action-selector                 
                        v-model="signpost_submission_id"
                        init_type='patient' 
                        :custom_actions="$root.provider.custom_action"
                        :user="form_user" 
                        ref="custom_action_selector">
                    </custom-action-selector>
                    <h3 class="pt-3 pb-3">{{ $t('translations.signpost_continue_existing') }}</h3>
                </div>
                <survey v-show='!signpost_items_visible' v-if='survey' :survey='survey' />
            </div>

            <!-- <custom-action-selector                 
                v-model="signpost_submission_id"
                init_type='patient' 
                :custom_actions="$root.provider.custom_action"
                :user="form_submission.user.id"
                :keyword_filter_mode="true">
            </custom-action-selector> -->
            <footer class='container-footer'>
                <span id="surveyProgress">
                    <template v-if='survey.visiblePageCount > 1'>
                        <button v-if="!survey.isFirstPage" class='btn btn-outline-primary btn-round' v-on:click="goBack();">{{$t('translations.prev')}}</button>
                        <button v-if="!survey.isLastPage" class='btn btn-outline-primary btn-round' v-on:click="nextPage();">{{$t('translations.next')}}</button>
                    </template>
                    <button v-if="survey.mode != 'display'" v-show="survey.isLastPage" class='btn btn-primary btn-round' :key="`complete_button_${complete_button_key}`" v-on:click.once="completeLastPageWrapper()">{{$t('translations.complete')}}</button>
                    <button v-else v-show="survey.isLastPage" class='btn btn-primary btn-round' v-on:click="closeSurvey();">{{$t('translations.close')}}</button>

                    <button v-show="survey.mode != 'display'" class='btn btn-outline-primary btn-round' v-on:click="saveProgress()">{{$t('translations.save_qa')}}</button>
                    <button v-show="survey.mode != 'display'" class='btn btn-warning btn-round float-right' v-on:click="cancel()">{{$t('translations.cancel')}}</button>
                </span>
            </footer>
        </div>
        
    </div>
</template>

<script>
//import * as SurveyVue from 'survey-vue';
export default {
    extends: app.base.formSubmissionBase,
}
</script>